export const graphConfig = {
  // Entra App Registration values supplied by Microsoft IT.
  clientId: 'a0e31d3c-1582-4447-afdb-af1388bd589d',
  tenantId: '057e5d5a-bbce-4097-bec8-4faab733e8e1',

  // Object ID for the IndependenceEX-Admins Entra security group.
  adminGroupId: 'd3ff3678-e75b-4023-bbd2-37ae65e6c182',

  // Still needed from SharePoint IT before Microsoft mode can activate.
  // Example: "https://contoso.sharepoint.com/sites/IndependenceEX"
  siteUrl: '',
}

export function isGraphConfigured() {
  return Boolean(
    graphConfig.clientId && graphConfig.tenantId && graphConfig.siteUrl,
  )
}

export const loginRequest = {
  scopes: [
    'User.Read',
    'User.ReadBasic.All',
    'Sites.ReadWrite.All',
    'Files.ReadWrite',
  ],
}
